import PDFGenerator from "./PDFGenerator";
export default PDFGenerator;
